/**
 * @group Auth
 * @summary Authentication defaults and constants
 * 
 * @remarks
 * This constant contains default values used in authentication,
 * including default tenant names, avatar paths, and fallback usernames.
 * 
 * @example
 * ```typescript
 * import { AUTH_DEFAULTS } from '@shared/constants';
 * 
 * const tenantName = user.tenant?.name || AUTH_DEFAULTS.TENANT_NAME;
 * const avatarUrl = user.avatar || AUTH_DEFAULTS.AVATAR_PATH;
 * ```
 */
export const AUTH_DEFAULTS = {
  TENANT_NAME: 'DEFAULT',
  AVATAR_PATH: '/default-avatar.png',
  FALLBACK_USERNAME: 'User'
} as const; 